const _excluded = ["className", "templates"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import CollectionLayout from './collection';
import { product } from './templates';
const TYPE = 'cards';
const DEFAULT_CLASSNAME = 'miso-cards';
const DEFAULT_TEMPLATES = Object.freeze({
  product
});
const INHERITED_DEFAULT_TEMPLATES = Object.freeze(Object.assign({}, CollectionLayout.defaultTemplates, {
  DEFAULT_TEMPLATES
}));
export default class CardsLayout extends CollectionLayout {
  static get type() {
    return TYPE;
  }
  static get defaultTemplates() {
    return INHERITED_DEFAULT_TEMPLATES;
  }
  static get defaultClassName() {
    return DEFAULT_CLASSNAME;
  }
  constructor() {
    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let {
        className = DEFAULT_CLASSNAME,
        templates
      } = _ref,
      options = _objectWithoutPropertiesLoose(_ref, _excluded);
    super(className, Object.assign({}, DEFAULT_TEMPLATES, templates), options);
  }
}